interface AccordionPanelProps {
  children: React.ReactNode;
  overrideClasses?: string;
  isOpen: boolean;
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({
  isOpen,
  overrideClasses,
  children,
}) => {
  return (
    <>
      {isOpen && (
        <div
          className={
            overrideClasses ? overrideClasses : `p-4 border-t bg-white`
          }
        >
          {children}
        </div>
      )}
    </>
  );
};

export default AccordionPanel;
